import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ActiveRunsResponse, researchApi } from "../../services/researchApi";
import { queryKeys } from "./keys";

const EMPTY: ActiveRunsResponse = { discovery: [], evaluation: [] };

const POLL_INTERVAL = 5_000;

/**
 * All in-flight discovery runs + evaluation candidate-tasks across every project
 * the user can access. Polls while `enabled` (e.g. the modal is open).
 */
export function useActiveRuns(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.research.activeRuns,
    queryFn: async (): Promise<ActiveRunsResponse> => {
      const response = await researchApi.getActiveRuns();
      return response ?? EMPTY;
    },
    enabled,
    // Poll while enabled (the modal is open); keep polling even when the window
    // isn't focused, and always refetch on (re)open so it opens with fresh data.
    refetchInterval: POLL_INTERVAL,
    refetchIntervalInBackground: true,
    refetchOnMount: "always",
    placeholderData: keepPreviousData,
  });
}
